import {
    updatePlaceholdersChangeModel,
    PLACEHOLDER_ADD,
    PLACEHOLDER_UPDATE,
    PLACEHOLDER_REMOVE
} from "../../models/model-utils"

export default function buildPlaceholdersPresentationReducer(
    actionTypes,
    canSave
) {
    const {
        ADD_PLACEHOLDER_IMAGES,
        UPDATE_PLACEHOLDER_ATTRIBUTION,
        REMOVE_PLACEHOLDER
    } = actionTypes
    return (state, action) => {
        const { type, images } = action
        switch (type) {
            case ADD_PLACEHOLDER_IMAGES: {
                const placeholdersToAdd = []
                for (let i = 0; i < images.length; i++) {
                    const image = images[i]
                    placeholdersToAdd.push({
                        image,
                        url: URL.createObjectURL(image),
                        attribution: ""
                    })
                }
                const updatedWorkingModel = state.workingModel.set(
                    "placeholders",
                    placeholdersToAdd.concat(state.workingModel.placeholders)
                )
                const updatedChangeModel = placeholdersToAdd.reduce(
                    (changeModel, placeholder) =>
                        updatePlaceholdersChangeModel(
                            PLACEHOLDER_ADD,
                            placeholder,
                            changeModel
                        ),
                    state.updateModel
                )
                return {
                    ...state,
                    workingModel: updatedWorkingModel,
                    updateModel: updatedChangeModel,
                    canSave: canSave(
                        updatedChangeModel,
                        state.imageToUpload,
                        updatedWorkingModel
                    )
                }
            }
            case UPDATE_PLACEHOLDER_ATTRIBUTION: {
                const { placeholder } = action
                const workingModel = state.workingModel
                const updatedPlaceholders = workingModel.placeholders.map(
                    storedPlaceholder => {
                        const { id, url } = storedPlaceholder
                        if ((id || url) === (placeholder.id || placeholder.url))
                            return placeholder
                        return storedPlaceholder
                    }
                )
                const updatedWorkingModel = workingModel.set(
                    "placeholders",
                    updatedPlaceholders
                )
                const updatedChangeModel = updatePlaceholdersChangeModel(
                    PLACEHOLDER_UPDATE,
                    placeholder,
                    state.updateModel
                )
                return {
                    ...state,
                    workingModel: updatedWorkingModel,
                    updateModel: updatedChangeModel,
                    canSave: canSave(
                        updatedChangeModel,
                        state.imageToUpload,
                        updatedWorkingModel
                    )
                }
            }
            case REMOVE_PLACEHOLDER: {
                const { placeholder } = action
                const updatedWorkingModel = state.workingModel.set(
                    "placeholders",
                    state.workingModel.placeholders.filter(
                        ({ id, url }) =>
                            (id || url) !== (placeholder.id || placeholder.url)
                    )
                )
                const updatedChangeModel = updatePlaceholdersChangeModel(
                    PLACEHOLDER_REMOVE,
                    placeholder,
                    state.updateModel
                )
                return {
                    ...state,
                    workingModel: updatedWorkingModel,
                    updateModel: updatedChangeModel,
                    canSave: canSave(
                        updatedChangeModel,
                        state.imageToUpload,
                        updatedWorkingModel
                    )
                }
            }
            default:
                return state
        }
    }
}
